import { AnimalKey } from 'api/query/search/animal-key.enum';
import { SearchAnimal } from 'api/query/search/search-animal';
import { Tag } from './tag';

/**
 * Predefined existing tags in website.
 */

export const getTagsWithId = (animalId: string): Tag[] => [
  {
    id: AnimalKey.ForSale,
    index: 1,
    chip: 'For sale',
    label: 'For Sale',
    type: 'primary',
  },
  {
    id: AnimalKey.SemenAvailable,
    index: 2,
    chip: 'Semen',
    label: 'Semen Available',
    type: 'primary',
  },
  {
    id: AnimalKey.IsDna,
    index: 3,
    chip: 'Genomics',
    label: 'Genomics',
    website: 'https://www.sheepgenetics.org.au/resources/genomics/',
    type: 'secondary',
  },
  {
    id: AnimalKey.SireInRefFlock,
    index: 4,
    chip: 'REF',
    label: 'Reference Flock',
    website: 'https://www.sheepgenetics.org.au/Resources/MLA-Resource-Flock',
    type: 'secondary',
  },
  {
    id: AnimalKey.IsMss,
    index: 5,
    chip: 'MSS',
    label: 'Merino Superior Sires',
    website: `http://database.merinosuperiorsires.com.au/wool_sire.php?id=${animalId}`,
    type: 'secondary',
  },
  {
    id: AnimalKey.IsMlp,
    index: 6,
    chip: 'MLP',
    label: 'Merino Lifetime Productivity Project',
    website: 'https://www.wool.com/sheep/genetics/merino-lifetime-productivity/',
    type: 'secondary',
  },
  {
    id: AnimalKey.SireInCpt,
    index: 7,
    chip: 'CPT',
    label: 'Central Progeny Test',
    type: 'secondary',
  },
  {
    id: AnimalKey.IsRegistered,
    index: 8,
    chip: 'REG',
    label: 'Registered',
    website: 'https://dohne.com.au/',
    type: 'secondary',
  },
];

export const getTags = (animal: SearchAnimal): Tag[] => getTagsWithId(animal.animalId);

export const showTagFromValue = (
  tag: Tag,
  show: 'all' | 'primary' | 'secondary',
) => (show === 'all' || show === tag.type);

export const showTagFromKey = (
  tag: Tag,
  tagOnAnimal: boolean,
  show: 'all' | 'primary' | 'secondary',
) => tagOnAnimal && showTagFromValue(tag, show);

/**
 * Returns true if a tag should be rendered, otherwise false.
 * @param tag
 */
export const showTag = (
  tag: Tag,
  animal: SearchAnimal,
  show: 'all' | 'primary' | 'secondary',
) => animal[tag.id] && (show === 'all' || show === tag.type);
